<script setup>
import apiDriveListeCommande from "@/services/http/api-drive/client/listeDeCommande";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useContextStore } from "@/store/context";
import { useMagasinStore } from "@/store/magasin";

const { layout } = storeToRefs(useContextStore());

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/mon-compte/mes-commandes/details/produits/${layout.value}.vue`
    ]
  );
});

const { trackPage } = useTrackingPage();

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.monCompte);
});

const { throwIfAxiosError } = useAxiosHelper();

const { id: magasinId } = useMagasinStore();
const { params } = useRoute();

const { data: res, error } = await useAsyncData((app) =>
  app.$apiDrive.use(apiDriveListeCommande).listeDeCommande(magasinId, params.id)
);
throwIfAxiosError(error);

const { data: commande, meta } = res.value;
</script>

<template>
  <component
    :is="component"
    :commande="commande"
    :meta="meta"
  />
</template>
